module.exports = "/_next/static/images/ma-7ccf0a173356280a0237e49f137a6098.svg";